<template>
    <MainSlot>
        <div class="events container page_bg">
            <div
                v-show="is_loaded_page"
                class="events_header">
                <div class="title_text">
                    <div>{{ $t(`Events['Events']`) }}</div>
                    <div class="btn white"
                         @click="openFiltersModal"
                    >
                        <svg
                            v-if="!is_filter_on"
                            width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21.9498 5.46027C22.7639 4.48328 22.0692 3 20.7974 3H3.20256C1.93081 3 1.23607 4.48329 2.05023 5.46028L9.07289 13.8875C9.67194 14.6063 10 15.5125 10 16.4482V19.7639C10 20.5215 10.428 21.214 11.1056 21.5528L12.5528 22.2764C13.2177 22.6088 14 22.1253 14 21.382V16.4482C14 15.5125 14.3281 14.6063 14.9271 13.8875L21.9498 5.46027Z"
                                fill="#FA604A"/>
                        </svg>
                        <svg
                            v-else
                            width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M18 12C21.3137 12 24 9.31371 24 6C24 2.68629 21.3137 0 18 0C14.6863 0 12 2.68629 12 6C12 9.31371 14.6863 12 18 12ZM21.2593 5.15079C21.6187 4.73147 21.5701 4.10017 21.1508 3.74074C20.7315 3.38132 20.1002 3.42988 19.7407 3.84921L17.4435 6.5293L16.2071 5.29289C15.8166 4.90237 15.1834 4.90237 14.7929 5.29289C14.4024 5.68342 14.4024 6.31658 14.7929 6.70711L16.7929 8.70711C16.9899 8.90407 17.26 9.00995 17.5384 8.99926C17.8167 8.98857 18.078 8.86228 18.2593 8.65079L21.2593 5.15079Z"
                                  fill="#FA604A"/>
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M10.1557 4.41907C10.2951 3.72368 9.80666 3 9.09743 3H3.20209C1.93033 3 1.2356 4.48329 2.04975 5.46028L9.07241 13.8875C9.67146 14.6063 9.99952 15.5125 9.99952 16.4482V19.7639C9.99952 20.5215 10.4275 21.214 11.1051 21.5528L12.5523 22.2764C13.2172 22.6088 13.9995 22.1253 13.9995 21.382V16.4482C13.9995 15.5125 14.3276 14.6063 14.9266 13.8875C15.0794 13.7041 15.0044 13.4243 14.7859 13.3284C11.9677 12.0908 9.99952 9.27523 9.99952 6C9.99952 5.45879 10.0533 4.93013 10.1557 4.41907Z"
                                  fill="#FA604A"/>
                        </svg>
                        <span>{{ $t(`Events['Filter']`) }}</span>
                    </div>
                </div>
            </div>
            <div v-if="serverParams.filter.locations.length || serverParams.filter.interests.length"
                 v-show="is_loaded_page"
                 class="tags_wrapper input-field col s12 outer_tags">
                <div
                    v-for="location of serverParams.filter.locations"
                    class="app_tag">
                    <img class="left" src="../assets/img/location_marker.svg" alt="location marker">
                    <div class="title">{{ location.title }}</div>
                    <svg
                        @click="deleteFilterLocationAndReload(location.title)"
                        width="12" height="12" viewBox="0 0 12 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>
                <div
                    v-for="interest of serverParams.filter.interests"
                    :key="interest.id"
                    class="app_tag">
                    <img src="../assets/img/tag-label-icon.svg"
                         class="left"
                         alt="tag-label-icon">
                    <div class="title">{{ interest.title }}</div>
                    <svg
                        @click="deleteUserTagAndReload('interests', interest.title)"
                        width="12" height="12" viewBox="0 0 12 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div
                v-if="!event_list.length"
                v-show="is_loaded_page"
                class="empty_state_wrapper">
                <img src="../assets/img/empty_state_image.svg" alt="empty-state-image">
                <div class="empty_state_text">
                    {{ empty_state_text }}
                </div>
            </div>
            <div v-else
                 v-show="is_loaded_page"
                 class="events_container">
                <div class="row">
                    <div
                        v-for="app_event of event_list"
                        class="col s12 m6 l4">
                        <div class="card pointer"
                             @click="navigateToEvent(app_event.id)"
                             :style="{backgroundImage:`url( '${app_event.image.url}' )`}"
                        >
                            <div class="card_body"></div>
                            <div class="card_content">
                                <div class="head_block">
                                    <div class="title">
                                        {{ app_event.title }}
                                    </div>
                                    <div class="info">
                                        <span>
                                            {{ dateTitle(app_event) }}
                                        </span>
                                    </div>
                                </div>

                                <div class="hovered_content">
                                    <div class="item">
                                        <span class="img"><img src="../assets/img/location_brand.svg"
                                                               alt="location_brand icon"></span>
                                        <span class="text">{{ app_event.location }}</span>
                                    </div>
                                    <div class="item">
                                        <span class="img"><img src="../assets/img/room-size_brand.svg" alt="room-size"></span>
                                        <span class="text">{{ app_event.seats_min }}
                                            {{
                                                app_event.seats_max ? ` - ${app_event.seats_max}` : ''
                                            }} {{ $t(`Events['users per conversation']`) }}</span>
                                    </div>
                                    <div class="item">
                                        <span class="img">
                                            <img src="../assets/img/host_brand.svg"
                                                 alt="host brand">
                                        </span>
                                        <span class="text">{{ app_event.organisation }}</span>
                                    </div>
                                    <div class="item">
                                        <span class="img">
                                            <img src="../assets/img/tag_brand.svg" alt="tag icon">
                                        </span>
                                        <span class="text">{{
                                                app_event.tags.reduce((accumulator, currentValue) => {
                                                    return accumulator
                                                        ? `${accumulator}, ${currentValue.title}`
                                                        : `${currentValue.title}`;
                                                }, '')
                                            }}</span>
                                    </div>
                                    <div class="desc">
                                        {{ shortDescription(app_event) }}
                                    </div>
                                </div>

                                <div class="footer">
                                    <div
                                        v-if="!app_event.is_reserved"
                                        @click.stop="reserveEvent(app_event)"
                                        class="btn white uppercase">
                                        {{ $t(`buttons['Reserve a seat']`) }}
                                    </div>
                                    <div v-else class="reserved_text">
                                        {{ $t(`Events['You’ve already reserved a seat']`) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- modal filters -->
        <div id="filters" ref="filters" class="modal h90">
            <div class="modal_header">
                <div>{{ $t(`Events['Filter']`) }}</div>
                <div @click="closeFilters" class="close_modal_btn">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.5 5.5L5.5 18.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M5.5 5.5L18.5 18.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div class="modal-content">
                <div class="row">
                    <div class="col m12 sub_title">
                        {{ $t(`Events['Locations:']`) }}
                    </div>
                    <div v-if="serverParams.filter.locations.length" class="tags_wrapper input-field col s12">
                        <div
                            v-for="location of serverParams.filter.locations"
                            class="app_tag">
                            <img class="left" src="../assets/img/location_marker.svg" alt="location marker">
                            <div class="title">{{ location.title }}</div>
                            <svg
                                @click="deleteFilterLocation(location.title)"
                                width="12" height="12" viewBox="0 0 12 12" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                                <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    <div class="input-field col m12 s12">
                        <input
                            id="location"
                            @keyup="onAutocompleteHandler"
                            ref="location"
                            :placeholder="$t(`Events['Start typing to add']`)"
                            type="text"
                        >
                    </div>
                    <div class="col m12 sub_title">
                        {{ $t(`Events['Event type:']`) }}
                    </div>
                    <div class="radio_event_type col m12">
                        <label>
                            <input class="with-gap"
                                   v-model="serverParams.filter.type"
                                   :value="types.all"
                                   name="event_type"
                                   type="radio"/>
                            <span>{{ $t(`Events['Any type']`) }}</span>
                        </label>
                        <label>
                            <input class="with-gap"
                                   v-model="serverParams.filter.type"
                                   :value="types.online"
                                   name="event_type"
                                   type="radio"/>
                            <span>{{ $t(`Events['Only online events']`) }}</span>
                        </label>
                        <label>
                            <input class="with-gap"
                                   v-model="serverParams.filter.type"
                                   :value="types.offline"
                                   name="event_type"
                                   type="radio"/>
                            <span>{{ $t(`Events['Only offline events']`) }}</span>
                        </label>
                    </div>
                    <div class="col m12 sub_title">
                        {{ $t(`Events['Tags:']`) }}
                    </div>
                    <div v-show="serverParams.filter.interests.length" class="tags_wrapper input-field col s12">
                        <div
                            v-for="interest of serverParams.filter.interests"
                            :key="interest.id"
                            class="app_tag">
                            <img src="../assets/img/tag-label-icon.svg"
                                 class="left"
                                 alt="tag-label-icon">
                            <div class="title">{{ interest.title }}</div>
                            <svg
                                @click="deleteUserTag('interests', interest.title)"
                                width="12" height="12" viewBox="0 0 12 12" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.5 10.5L1.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                                <path d="M1.5 10.5L10.5 1.5" stroke="#FA604A" stroke-width="3" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    <div class="input-field col m12 s12">
                        <input id="interests"
                               ref="interests"
                               :placeholder="$t(`Events['Start typing to add']`)"
                               type="text">
                    </div>
                </div>
                <div class="buttons_wrapper_between two">
                    <div @click="clearFilters" class="btn white clear_but">
                        {{ $t(`buttons['CLEAR ALL']`) }}
                    </div>
                    <div @click="applyFilters" class="btn">
                        {{ $t(`buttons['APPLY']`) }}
                    </div>
                </div>
            </div>
        </div>
        <!--        success_reservation_modal        -->
        <div id="success_reservation_modal" ref="success_reservation_modal" class="modal content-width">
            <div class="modal_header">
                {{ $t("MainSlot['Reserve a seat']") }}
            </div>
            <div class="modal-content">
                <p class="content_title">{{ $t("MainSlot['Congratulations!']") }}</p>

                <p>
                    {{ $t("MainSlot['You have reserved a seat at a new event.']") }} <br>
                    {{ $t("MainSlot['You can cancel your reservation at any time.']") }}
                </p>
                <div class="buttons_wrapper_between center">
                    <div
                        @click="closeSuccessReservationModal"
                        class="btn w180">
                        {{ $t(`buttons.OK`) }}
                    </div>
                </div>
            </div>
        </div>
    </MainSlot>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import {errorMessage} from "../services/messges";
import {mapMutations, mapGetters, mapActions} from 'vuex';
import {eventDurationString} from '../services/tools';
import moment from "moment-timezone";
import event_modal_data from '../store/event_modal_data.js'
import {removeMapsScriptsFromHead} from "../../../admin_panel/src/services/tools";
import EventTypeEnum from "../models/EventTypeEnum";


export default {
    data() {
        return {
            autocomplete: {
                draw: 0
            },
            autocompletes: {
                interests: {
                    instance: null,
                    data: []
                }
            },
            event: {},
            empty_state_text: this.$t("Events['Sorry, nothing here yet.']"),
            event_list: [],
            isLoading: false,
            total_count: 0,
            filtersCopy: {
                locations: [],
                interests: [],
            },
            serverParams: {
                has_next: true,
                offset: 0,
                limit: 90,
                filter: {
                    type: this.selectedEventType(),
                    locations: [],
                    interests: [],
                },
                sort: [{
                    field: '',
                    type: '',
                }],
                search: '',
            },
            modals: {
                filter: null,
                reservation_modal: null,
                success_reservation_modal: null,
                current_modal_content: {},
                available_contents: {}
            }
        };
    },
    methods: {
        ...mapMutations([
            'set_after_login',
            'setLoading',
            'set_is_loaded_page',
        ]),
        ...mapActions([
            'loadTags',
            'loadAutocompleteData',
            'loadNearestMeetingsInfo',
        ]),
        selectedEventType() {
            const storedType = localStorage.getItem('selectedEventType');
            return [EventTypeEnum.ALL, EventTypeEnum.OFFLINE, EventTypeEnum.ONLINE].some(v => v === storedType)
                ? storedType
                : EventTypeEnum.ALL;
        },
        runFunc(name) {
            try {
                if (name) {
                    this[name]();
                }
            } catch (e) {
                console.log(e);
            }
        },
        closeReservationModal() {
            this.modals.reservation_modal?.close()
        },
        closeSuccessReservationModal() {
            this.modals.success_reservation_modal?.close()
        },
        openReservationModal() {
            this.modals.reservation_modal?.open();
            this.loadNearestMeetingsInfo(true);
        },
        openSuccessReservationModal() {
            this.modals.success_reservation_modal?.open();
            this.loadNearestMeetingsInfo(true);
        },
        cancelReserveSeatConfirmModal() {
            this.modals.current_modal_content = this.modals.available_contents.confirm_reservation_cancel;
            this.openReservationModal();
        },
        cancelReserveSeatConfirmed() {
            this.closeReservationModal()
            this.modals.current_modal_content = this.modals.available_contents.success_reservation_cancel;
            this.reservation(false, 'openReservationModal')
        },
        reserveSeat() {
            this.modals.current_modal_content = this.modals.available_contents.success_reservation;
            this.reservation(true, 'openSuccessReservationModal')
        },
        async reservation(is_reserve, on_success = null) {
            const event_id = this.event.id;
            try {
                this.setLoading(true);
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/events/${event_id}/reserve`, {
                    remove: !is_reserve
                });
                if (response && response.data && response.data.success) {
                    if (on_success) {
                        this[on_success]();
                    }
                    this.event.is_reserved = is_reserve;
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['OOPS... Something went wrong...']"));
            }
            this.setLoading(false);
        },
        destroyReservationModal() {
            if (this.modals.reservation_modal) {
                this.modals.reservation_modal?.destroy();
                this.modals.reservation_modal = null;
            }
        },
        destroySuccessReservationModal() {
            if (this.modals.success_reservation_modal) {
                this.modals.success_reservation_modal?.destroy();
                this.modals.success_reservation_modal = null;
            }
        },
        async navigateToEvent(event_id) {
            try {
                await this.$router.push(`/events-app/${event_id}/details`)
            } catch (e) {
                console.log(e);
            }
        },
        reInitAutocompleteInterests() {
            this.autocompletes.interests.data = this.getTags;
            if (this.autocompletes.interests.instance) {
                this.autocompletes.interests.instance?.destroy();
                this.autocompletes.interests.instance = null;
            }
            this.autocompletes.interests.instance = M.Autocomplete.init(this.$refs.interests, {
                data: this.interestsObject,
                onAutocomplete: (title) => {
                    this.addInterest(title);
                    this.$refs.interests.value = null;
                    this.$refs.interests.focus();
                }
            });
        },
        addInterest(title) {
            if (!this.inArrayByTitle('interests', title)) {
                this.serverParams.filter.interests.push(this.autocompletes.interests.data.find(el => el.title === title))
            }
        },
        inArrayByTitle(array_prop, title) {
            return this.serverParams.filter[array_prop].some(el => el.title === title);
        },
        deleteUserTag(prop, title) {
            this.serverParams.filter[prop] = this.serverParams.filter[prop].filter(el => el.title !== title);
        },
        deleteUserTagAndReload(prop, title) {
            this.serverParams.filter[prop] = this.serverParams.filter[prop].filter(el => el.title !== title);
            this.loadItems({offset: 0});
        },
        durationOfEvent(event) {
            return eventDurationString(event);
        },
        async reserveEvent(event) {
            this.event = event;
            this.reserveSeat();
        },
        shortDescription(app_event) {
            const desc = app_event.description;
            return desc.length < 220 ? desc : desc.substr(0, 220) + '...';
        },
        dateTitle(app_event) {
            return moment(app_event.start_date_time).format('DD.MM.YYYY, HH:mm');
        },
        async loadItems(params = {}) {
            try {
                this.serverParams = Object.assign(this.serverParams, params);
                this.setLoading(true);
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/events/list`,
                    this.serverParams);
                this.event_list = response?.data?.data?.list || [];
                this.total_count = response?.data?.data?.total_count || 0;
                const next_offset = this.serverParams.offset + this.serverParams.limit;
                this.serverParams.has_next = (this.total_count - 1) <= next_offset;
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['OOPS... Something went wrong...']"));
            }

            this.empty_state_text = this.is_filter_on ? this.$t("Events['Sorry, but nothing found. Try something else.']") : this.$t("Events['Sorry, nothing here yet.']");

            this.set_is_loaded_page(true);
        },
        closeFilters() {
            this.modals.filter.close();
            this.serverParams.filter = Object.assign({}, this.filtersCopy);
        },
        clearFilters() {
            this.serverParams.filter = {
                locations: [],
                interests: [],
            };
            this.modals.filter.close();
            this.loadItems({offset: 0});
        },
        openFiltersModal() {
            if (!this.modals.filter) {
                this.reInitModals();
            }

            this.modals.filter.open();
        },
        applyFilters() {
            this.modals.filter.close();
            this.loadItems({offset: 0});
        },
        sleep(milliseconds) {
            return new Promise((resolve, reject) => {
                let wait = setTimeout(() => {
                    clearTimeout(wait);
                    resolve('done');
                }, milliseconds)
            })
        },
        async onAutocompleteHandler(ev) {
            this.autocomplete.draw += 1;
            const search = ev.target.value;
            if (!search || search.length < 2) {
                return;
            }
            try {
                const draw = this.autocomplete.draw;
                await this.sleep(400);
                if (draw !== this.autocomplete.draw) {
                    return;
                }
                const {data} = await this.$http.postAuth(`${this.$http.apiUrl()}users/events/locations/autocomplete`,
                    {search, draw});

                if (draw !== this.autocomplete.draw) {
                    return;
                }

                if (data.data && data.data.list) {
                    this.autocomplete.availableLocations = data.data.list;
                    const variants = {};
                    for (const item of data.data.list) {
                        variants[item.title] = null;
                    }
                    this.autocomplete.variants = variants;
                    this.reInitAutocomplete();
                    this.$refs.location.click();
                }
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['OOPS... Something went wrong...']"));
            }
        },
        reInitAutocomplete(object) {
            if (this.autocomplete.location) {
                this.autocomplete.location?.destroy();
                this.autocomplete.location = null;
            }
            this.autocomplete.location = M.Autocomplete.init(this.$refs.location, {
                data: object || this.autocomplete.variants,
                onAutocomplete: (title) => {
                    this.addFilteredLocation(title);
                    this.$refs.location.value = null;
                }
            });
        },
        addFilteredLocation(title) {
            if (!this.isFilterLocationContainsTitle(title)) {
                this.serverParams.filter.locations.push(this.autocomplete.availableLocations.find(el => {
                    return el.title === title;
                }));
            }
        },
        isFilterLocationContainsTitle(title) {
            return this.serverParams.filter.locations.some(el => {
                return el.title === title;
            })
        },
        deleteFilterLocation(title) {
            this.serverParams.filter.locations = this.serverParams.filter.locations.filter(el => {
                return el.title !== title;
            })
        },
        deleteFilterLocationAndReload(title) {
            this.serverParams.filter.locations = this.serverParams.filter.locations.filter(el => {
                return el.title !== title;
            });
            this.loadItems({offset: 0});
        },
        destroyFiltersModal() {
            if (this.modals.filter) {
                this.modals.filter?.destroy();
                this.modals.filter = null;
            }
        },
        reInitModals() {
            this.destroyFiltersModal();
            this.modals.filter = M.Modal.init(this.$refs.filters, {
                dismissible: false,
                onOpenStart: () => {
                    const {interests, locations} = this.serverParams.filter;
                    this.filtersCopy = {interests: [...interests], locations: [...locations]}
                }
            });
            this.destroyReservationModal();
            this.modals.reservation_modal = M.Modal.init(this.$refs.reservation_modal);
            this.destroySuccessReservationModal();
            this.modals.success_reservation_modal = M.Modal.init(this.$refs.success_reservation_modal);
        },
        changeTab(value) {
            this.serverParams.filter.active_tab = this.selectedTab = value;
            this.loadItems();
        },
        async onRowClick({row}) {
            this.setCurrentEvent(row);
            await this.$router.push(`/events-app/${row.id}/details`);
        },
        onSearch(search) {
            this.updateParams({search: search.searchTerm});
            this.loadItems();
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.loadItems();
        },
        onSortChange(params) {
            this.updateParams({
                sort: params,
            });
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.loadItems();
        },
        async toCreateEvent() {
            try {
                await this.$router.push('/events-app/create')
            } catch (e) {
                console.log(e);
            }
        },
        async afterLoginChecked() {
            await this.loadAutocompleteData();
            await this.loadTags();
            await this.loadItems();
            this.scrollToTop();
            this.reInitAutocompleteInterests();
            await this.$emit('notification-permission');
        },
        scrollToTop() {
            const container = document.querySelector('.page_bg');
            if (container) {
                container.scrollTop = 0;
                container?.scroll({top: 0})
            }
            window.scrollTop = 0;
            window?.scroll({top: 0});
            document && document.body && document.body.style && document.body.style.transform ? document.body.style.transform = 'none' : null;
        }
    },
    async mounted() {
        this.set_is_loaded_page(false)
        await this.$emit('check-login', '/public/events');
        if (this.isLoginChecked) {
            this.reInitModals();
            this.modals.available_contents = event_modal_data;
            await this.afterLoginChecked();
        }
    },
    computed: {
        ...mapGetters([
            'is_after_login',
            'isLoginChecked',
            'getCurrentEvent',
            'getInterests',
            'getTags',
            'get_refresh_event_status',
            'is_loaded_page',
        ]),
        types() {
            return {
                all: EventTypeEnum.ALL,
                online: EventTypeEnum.ONLINE,
                offline: EventTypeEnum.OFFLINE,
            }
        },
        generateCancelConfirmContent() {
            return `${this.$t("MainSlot['Are you sure you want to cancel your reservation for']")} <span class="strong">”${this.event.title}” ${this.$t("MainSlot['on']")} ${this.eventDate}<strong>?`
        },
        eventDate() {
            const date = moment(this.event.start_date_time);
            return `${date.format('MMM DD, YYYY')}`;
        },
        is_filter_on() {
            return this.serverParams.filter.locations.length || this.serverParams.filter.interests.length;
        },
        interestsObject() {
            const obj = {};
            for (let lang of this.autocompletes.interests.data) {
                obj[lang.title] = null;
            }
            return obj;
        },
    },
    watch: {
        ['serverParams.filter.type'](val) {
            localStorage.setItem('selectedEventType', val);
        },
        get_refresh_event_status(val) {
            if (this.event_list.some((ev) => {
                return +ev.id === +val.id;
            })) {
                this.event_list = this.event_list.map((ev) => {
                    if (+ev.id === +val.id) {
                        ev.is_reserved = val.is_reserved;
                    }
                    return ev;
                });
            }
        },
        async isLoginChecked(val) {
            if (val) {
                await this.afterLoginChecked();
            }
        },
        getInterests(val) {
            this.reInitAutocompleteInterests();
        },
        getTags(val) {
            this.reInitAutocompleteInterests();
        }
    },
    beforeDestroy() {
        if (this.autocompletes.interests.instance) {
            this.autocompletes.interests.instance?.destroy();
            this.autocompletes.interests.instance = null;
        }
        this.destroyFiltersModal();
        this.destroyReservationModal();
        removeMapsScriptsFromHead();
    },
    components: {
        VueGoodTable,
    },
    metaInfo: {
        title: 'Events Page',
        titleTemplate: '%s | Speed Friending Webapp'
    },
    name: "Events"
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables";

.radio_event_type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 30px;

    label {
        margin: 5px 0;
    }

    [type="radio"].with-gap:checked + span:before,
    [type="radio"]:not(:checked) + span:before {
        border: 1px solid #B8B5C8;
    }

    [type="radio"].with-gap:checked + span:after {
        transform: scale(0.7);
    }

    [type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:after {
        background-color: #FA604A;
    }

    [type="radio"]:checked + span:after,
    [type="radio"].with-gap:checked + span:after {
        border: none;
    }

    span {
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        color: #555A63;
    }
}

#filters {
    max-width: 540px;

    .modal_header {
        padding: 15px;
        position: static;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 62px;

        .close_modal_btn {
            position: static;
            margin-right: 5px;
        }
    }

    .buttons_wrapper_between {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 15px 0px;

        .btn {
            margin: 3px 10px;
            min-width: auto;
            width: calc(50% - 20px) !important;
        }

        .clear_but {
            white-space: nowrap;
        }
    }
}

.modal_header {

    svg {
        margin-right: -4px;
    }
}

.modal-content {
    padding: 28px 20px 12px !important;
}

.outer_tags {
    justify-content: flex-end;
}

.reserved_text {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    color: white;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;

    svg {
        margin-right: 10px;
    }
}

.row {
    margin: 20px -0.75rem;

    #filters & {
        margin: 0;
    }

    .col {
        display: flex;
        justify-content: center;

        #filters & {
            justify-content: flex-start;
        }
    }
}

.card {
    width: 350px;
    max-width: 100%;
    height: 400px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 24px;
    overflow: hidden;

    @media screen and (max-width: 601px) {
        //height: 300px;
        width: 100%;
    }

    .card_content {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        z-index: 1;

        .hovered_content {
            height: 0;
            overflow: hidden;

            .desc {
                margin-top: 15px;
                font-style: normal;
                font-weight: normal;
                font-size: 15px;
                line-height: 20px;
                color: white;
                height: 100px;
                max-height: 100px;
            }

            .item {
                padding: 15px 0 0;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .text {
                    font-style: normal;
                    font-weight: normal;
                    font-size: 15px;
                    line-height: 20px;
                    color: white;
                }

                .img {
                    padding-right: 7px;
                    display: flex;
                }
            }

        }

        .head_block {
            color: white;

            .info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-style: normal;
                font-weight: 600;
                font-size: 13px;
                line-height: 16px;
                color: white;
                padding-top: 3px;
            }

            .title {
                font-style: normal;
                font-weight: bold;
                font-size: 18px;
                line-height: 23px;
            }
        }

        .footer {
            margin-top: 15px;
            height: 56px;

            .btn {
                width: 80%;
                margin: 0 auto;
            }
        }
    }

    &:hover {
        .hovered_content {
            height: 255px;
        }

        .card_body, .card_body_second {
            background-color: #3A0143cc;
            //background:  linear-gradient(90deg, #FA604A 0%, #9235A1 100%);
        }
    }

    .card_body {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 15px;
        background: linear-gradient(180deg, rgba(58, 1, 67, 0) 45.06%, rgba(58, 1, 67, 0.84) 74.04%, #3A0143 100%);;
        opacity: 0.75;
    }

    .card_body_second {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 15px;
        background: linear-gradient(90deg, #FA604A 0%, #9235A1 100%);;
        opacity: 0.75;
    }
}

.page_bg {
    @media screen and (max-width: 601px) {
        padding: 15px;
    }
}

.title_text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.events_content {
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.events_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    text-transform: none;
}

.sub_title {
    margin: 0;
}

.input-field {
    margin-top: 17px;
}

</style>
